import React from 'react'
import type { Track } from 'types/track'
import { STEM } from '@disco/constants/Nesting'
import { AccordionWrapper } from 'components/explorer/pane/explorer-track-versions/ExplorerTrackVersions'
import type { TrackVersionsProps } from 'components/nesting/track-versions-container'
import TrackVersionsContainer from 'components/nesting/track-versions-container'
import UseWithCautionDeferredRender from 'components/ui/use-with-caution-deferred-render'
export const PlaylistTrackVersions = ({
  versions,
  stems,
  parentProps,
  mainTrack,
  currentTrackIndex,
}: TrackVersionsProps): React.ReactNode => {
  return (
    <UseWithCautionDeferredRender>
      <div className="ExplorerTrackVersions__CollapsibleContainer">
        {versions && (
          <AccordionWrapper
            mainTrack={mainTrack}
            parentProps={parentProps}
            items={versions}
            nestingLabel={null}
            title="VERSIONS"
            itemPrefix={`versions-${currentTrackIndex || 0}`}
            open
          />
        )}
        {stems && (
          <AccordionWrapper
            mainTrack={mainTrack}
            parentProps={parentProps}
            items={stems}
            title="STEMS"
            nestingLabel={STEM}
            itemPrefix={`stems-${currentTrackIndex || 0}`}
          />
        )}
      </div>
    </UseWithCautionDeferredRender>
  )
}

const PlaylistTrackVersionsContainer = ({
  mainTrack,
  currentTrackIndex,
}: {
  mainTrack: Track
  currentTrackIndex: number
}): React.ReactNode => (
  <TrackVersionsContainer
    mainTrack={mainTrack}
    component={PlaylistTrackVersions}
    currentTrackIndex={currentTrackIndex}
  />
)

export default PlaylistTrackVersionsContainer
